









import { defineComponent } from '@vue/composition-api'

// ================================
// Type
// ================================
export type OverlayProps = {
  activeMenu: boolean;
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'Overlay',
  props: ['activeMenu', 'toggleMenu'],
  setup (props: OverlayProps) {
    return {
      props
    }
  }
})
